import { useContext, useMemo } from "react";
import { AppContext } from "../../../../../AppContext";
import { useGetDocTypeList } from "../../../../../shared/hooks/useDocTypesData";
import { FIELDS, FILTERS, VALIDATION } from "../constants";

export const useCashOutData = () => {
    const { userInfo, company } = useContext(AppContext);

    // Fetch employee for current user
    const { data: getEmployee } = useGetDocTypeList({
        doctype: "Employee",
        filters: FILTERS.USER_EMPLOYEE(userInfo.name),
    });

    // Fetch purchase items
    const { data: getPurchaseItems } = useGetDocTypeList({
        doctype: "Item",
        filters: FILTERS.PURCHASE_ITEMS,
    });

    // Fetch expense accounts
    const { data: expenseAccounts } = useGetDocTypeList({
        doctype: "Account",
        filters: [...FILTERS.EXPENSE_ACCOUNTS, ["company", "=", company?.name]],
    });

    // Get suppliers for expense purchase invoices
    const { data: suppliers } = useGetDocTypeList({
        doctype: "Supplier",
        filters: FILTERS.SUPPLIERS,
        fields: FIELDS.SUPPLIER,
    });

    // Get employees for advance selection
    const { data: employees } = useGetDocTypeList({
        doctype: "Employee",
        filters: FILTERS.ACTIVE_EMPLOYEES,
        fields: FIELDS.EMPLOYEE,
    });

    // Get item groups for item creation
    const { data: itemGroups } = useGetDocTypeList({
        doctype: "Item Group",
        filters: FILTERS.LEAF_ITEM_GROUPS,
        fields: FIELDS.ITEM_GROUP,
    });

    // Get current employee
    const currentEmployee = useMemo(() => {
        if (employees && employees.length > 0) {
            const userEmployee = employees.find(
                (emp) => emp.user_id === userInfo.name
            );
            return userEmployee ? userEmployee.name : null;
        }
        return null;
    }, [employees, userInfo.name]);

    // Filter items based on search text
    const getFilteredItems = (itemSearchText) => {
        if (!getPurchaseItems) return [];

        let items = getPurchaseItems;

        // Filter by search text if provided
        if (itemSearchText) {
            items = items.filter(
                (item) =>
                    item.item_name
                        .toLowerCase()
                        .includes(itemSearchText.toLowerCase()) ||
                    item.item_code
                        .toLowerCase()
                        .includes(itemSearchText.toLowerCase())
            );
        }

        return items.slice(0, VALIDATION.MAX_ITEMS_DISPLAY);
    };

    return {
        // User and company context
        userInfo,
        company,

        // Data from API
        getEmployee,
        getPurchaseItems,
        expenseAccounts,
        suppliers,
        employees,
        itemGroups,

        // Computed values
        currentEmployee,
        getFilteredItems,
    };
};
